<template>
  <div class="loading">
    <img src="../../assets/LOGO_Loading.gif" />
  </div>
</template>

<script>
export default {
  name: "loadPage",
};
</script>

<style scoped>
.loading {
  width: 100%;
  height: 100%;
  background-color: grey;
}
</style>
